/* ==========================================================================
   Viva Melhor · Ofertas no tema (substitui o Monk e o Kaching Bundles)
   - Brindes automáticos no carrinho (adiciona e retira conforme as regras)
   - Opções de compra na página do produto (Compre 1 / 2 / 3)
   - Carrinho lateral inteligente: portes grátis, ofertas e sugestões
   - Pesquisa inteligente por necessidade
   As regras vêm da secção «VM · Ofertas e carrinho» (#vm-ofertas-config).
   ========================================================================== */
(function () {
  'use strict';
  if (window.VMOfertas) return;

  var cfgEl = document.getElementById('vm-ofertas-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { if (window.console) console.warn('[VM Ofertas] configuração inválida', e); return; }
  ['rules', 'tiers', 'cross', 'needs', 'bestsellers'].forEach(function (k) { if (!Array.isArray(CFG[k])) CFG[k] = []; });

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || CFG.rootUrl || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var FREE = parseInt(CFG.freeShipping, 10) || 0;
  var IS_CART_PAGE = /\/cart\/?$/.test(window.location.pathname);

  /* ------------------------------------------------------------------ utilidades */
  var NF = null;
  try {
    NF = new Intl.NumberFormat('pt-PT', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR' });
  } catch (e) { NF = null; }
  function money(c) {
    var v = (Number(c) || 0) / 100;
    return NF ? NF.format(v) : v.toFixed(2).replace('.', ',') + ' €';
  }
  function moneyShort(c) {
    var v = (Number(c) || 0) / 100;
    if (Math.round(v) === v) return String(v) + ' €';
    return money(c);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function imgUrl(u, w) {
    if (!u) return '';
    u = String(u);
    if (u.indexOf('//') === 0) u = 'https:' + u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function sum(arr, f) { var t = 0; for (var i = 0; i < arr.length; i++) t += f(arr[i]) || 0; return t; }
  function parseList(s) { return String(s || '').split(/[,;|\n]+/).map(function (t) { return t.trim(); }).filter(Boolean); }
  function parseTiers(s) {
    var out = [];
    String(s || '').split(/[^0-9]+/).forEach(function (x) {
      var n = parseInt(x, 10);
      if (n > 0 && n < 100 && out.indexOf(n) < 0) out.push(n);
    });
    return out.sort(function (a, b) { return a - b; });
  }
  function norm(s) {
    s = String(s || '').toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { /* sem normalize */ }
    return s;
  }
  function fill(tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; });
  }
  function shortTitle(t) { return String(t || '').split(' - ')[0].split(' | ')[0].split(' _ ')[0].split(' – ')[0].trim(); }
  var ICON = {
    truck: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg>',
    gift: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>',
    x: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    lock: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>',
    bag: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>'
  };

  /* ------------------------------------------------------------------ API do carrinho */
  function req(url, body) {
    return fetch(ROOT + url, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok || (d && d.status && d.status >= 400)) {
          var err = new Error((d && (d.description || d.message)) || 'Não foi possível atualizar o carrinho.');
          err.data = d;
          throw err;
        }
        return d;
      });
    });
  }
  var Cart = {
    get: function () { return req('cart.js?_=' + Date.now()); },
    add: function (items) { return req('cart/add.js', { items: items }); },
    update: function (updates) { return req('cart/update.js', { updates: updates }); },
    change: function (key, qty) { return req('cart/change.js', { id: key, quantity: qty }); }
  };

  /* ------------------------------------------------------------------ motor de brindes */
  var FREE_GIFT = {};
  CFG.rules.forEach(function (r) {
    r.products = Array.isArray(r.products) ? r.products : [];
    r.gifts = Array.isArray(r.gifts) ? r.gifts.filter(function (g) { return g && g.variant; }) : [];
    r.min = parseInt(r.min, 10) || 1;
    r.max = parseInt(r.max, 10) || 0;
    r.repeat = !!r.repeat;
    r.gifts.forEach(function (g) { g.qty = parseInt(g.qty, 10) || 1; if (!g.price) FREE_GIFT[g.variant] = true; });
    r.on0 = !!r.on;
    r.from = parseInt(r.from, 10) || 0;
    r.until = parseInt(r.until, 10) || 0;
  });
  var RULE_BY_ID = {};
  CFG.rules.forEach(function (r) { RULE_BY_ID[r.id] = r; });

  /* Agendamento: cada oferta só está ativa entre «Ativa a partir de» e «Termina em» (hora do navegador).
     Fora desse intervalo conta como desligada e os seus brindes saem do carrinho. */
  function agora() { return Math.max(typeof window.vmAgora === 'function' ? window.vmAgora() : Date.now(), parseInt(CFG.now, 10) || 0); }
  function refreshRules() {
    var t = agora();
    CFG.rules.forEach(function (r) { r.on = r.on0 && (!r.from || t >= r.from) && (!r.until || t < r.until); });
  }
  refreshRules();

  /* Ofertas acumulativas: com «repeat», a oferta repete-se a cada [mínimo] artigos
     (compre 2 → 1 brinde, compre 4 → 2 brindes, compre 6 → 3 brindes, …). */
  function timesFor(r, count) { return r.repeat ? Math.floor(count / Math.max(1, r.min)) : 1; }
  function giftQtyFor(r, g, count) { return r.scale ? Math.min(count, g.qty) : g.qty * timesFor(r, count); }

  function props(i) { return i && i.properties && typeof i.properties === 'object' ? i.properties : {}; }
  function giftRuleOf(i) { var p = props(i); return p._vm_brinde ? String(p._vm_brinde) : ''; }
  function isGift(i) { return !!giftRuleOf(i) || !!FREE_GIFT[i.variant_id]; }
  function signature(cart) {
    return cart.items.filter(function (i) { return !isGift(i); }).map(function (i) { return i.variant_id + 'x' + i.quantity; }).sort().join(',');
  }
  var BLOCK_KEY = 'vmOfertasLimite';
  function getBlocked() { try { return JSON.parse(window.sessionStorage.getItem(BLOCK_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function setBlocked(o) { try { window.sessionStorage.setItem(BLOCK_KEY, JSON.stringify(o)); } catch (e) { /* sem armazenamento */ } }

  function evaluate(cart) {
    refreshRules();
    var items = (cart && cart.items) || [];
    var paid = items.filter(function (i) { return !isGift(i); });
    var totalQty = sum(paid, function (i) { return i.quantity; });
    var desired = {};
    var status = [];
    if (CFG.enabled === false) return { paid: paid, total: totalQty, desired: desired, status: status };
    CFG.rules.forEach(function (r) {
      if (!r.on || !r.gifts.length) return;
      var inList = paid.filter(function (i) { return r.products.indexOf(i.product_id) > -1; });
      var listQty = sum(inList, function (i) { return i.quantity; });
      var count = r.mode === 'lista' ? listQty : totalQty;
      var over = !!(r.max && count > r.max);
      var met = listQty > 0 && count >= r.min && !over;
      var gifts = r.gifts.map(function (g) {
        return { g: g, qty: met ? giftQtyFor(r, g, count) : 0 };
      });
      var rest = r.repeat && met ? count % r.min : 0;
      var next = rest > 0 ? r.min - rest : 0;
      gifts.forEach(function (x) {
        if (x.g.available === false) return;
        var k = r.id + '|' + x.g.variant;
        desired[k] = { qty: (desired[k] ? desired[k].qty : 0) + x.qty, rule: r, gift: x.g };
      });
      status.push({ rule: r, met: met, over: over, count: count, listQty: listQty, inList: inList, need: Math.max(0, r.min - count), next: next, gifts: gifts });
    });
    return { paid: paid, total: totalQty, desired: desired, status: status };
  }

  var running = null;
  var again = false;
  function reconcile() {
    if (CFG.enabled === false) return Cart.get().then(function (c) { return { cart: c, changed: false }; });
    if (running) { again = true; return running; }
    running = doReconcile().then(function (res) {
      running = null;
      if (again) {
        again = false;
        return reconcile().then(function (res2) { res2.changed = res2.changed || res.changed; return res2; });
      }
      return res;
    }, function (err) {
      running = null;
      again = false;
      if (window.console) console.warn('[VM Ofertas]', err);
      return Cart.get().then(function (c) { return { cart: c, changed: false }; });
    });
    return running;
  }

  function doReconcile() {
    var changed = false;
    var blocked = getBlocked();
    var readded = {};

    function step(cart, n) {
      if (n > 5) return Promise.resolve(cart);
      var sig = signature(cart);
      var ev = evaluate(cart);

      // 1) acertar as quantidades de brindes
      var groups = {};
      cart.items.forEach(function (i) {
        if (!isGift(i)) return;
        var k = giftRuleOf(i) + '|' + i.variant_id;
        if (!groups[k]) groups[k] = { lines: [], qty: 0 };
        groups[k].lines.push(i);
        groups[k].qty += i.quantity;
      });
      Object.keys(ev.desired).forEach(function (k) { if (!groups[k]) groups[k] = { lines: [], qty: 0 }; });
      var updates = {};
      var hasUpdates = false;
      var adds = [];
      Object.keys(groups).forEach(function (k) {
        var d = ev.desired[k];
        var target = d ? d.qty : 0;
        var b = blocked[k];
        if (b && b.s === sig) target = Math.min(target, b.m);
        var g = groups[k];
        if (g.qty > target) {
          var excess = g.qty - target;
          g.lines.slice().sort(function (a, c) { return (c.final_line_price > 0) - (a.final_line_price > 0); }).forEach(function (l) {
            if (!excess) return;
            var r = Math.min(excess, l.quantity);
            updates[l.key] = l.quantity - r;
            excess -= r;
            hasUpdates = true;
          });
        } else if (g.qty < target) {
          var parts = k.split('|');
          adds.push({ id: parseInt(parts[1], 10), quantity: target - g.qty, properties: { _vm_brinde: parts[0] } });
        }
      });
      if (hasUpdates || adds.length) {
        changed = true;
        var p = hasUpdates ? Cart.update(updates) : Promise.resolve();
        return p.then(function () {
          if (adds.length) return Cart.add(adds).catch(function (e) { if (window.console) console.warn('[VM Ofertas] brinde indisponível', e); });
        }).then(Cart.get).then(function (c) { return step(c, n + 1); });
      }

      // 2) garantir que os brindes ficam gratuitos (desconto da loja ou produto a 0 €)
      var byVar = {};
      cart.items.forEach(function (i) {
        var v = i.variant_id;
        var o = byVar[v] || (byVar[v] = { gift: 0, free: 0, unit: i.original_price || i.price || 0, giftLines: [], charged: false });
        var disc = sum(i.line_level_discount_allocations || [], function (a) { return a.amount; });
        if (giftRuleOf(i) || FREE_GIFT[v]) {
          o.gift += i.quantity;
          o.giftLines.push(i);
          if (i.final_line_price > 0) o.charged = true;
        }
        o.free += o.unit > 0 ? Math.round(disc / o.unit) : i.quantity;
      });
      var fix = null;
      Object.keys(byVar).some(function (v) {
        var o = byVar[v];
        if (!o.gift || o.unit === 0) return false;
        if (o.free < o.gift) {
          var reduce = o.gift - o.free;
          var up = {};
          o.giftLines.slice().sort(function (a, c) { return (c.final_line_price > 0) - (a.final_line_price > 0); }).forEach(function (l) {
            if (!reduce) return;
            var r = Math.min(reduce, l.quantity);
            up[l.key] = l.quantity - r;
            reduce -= r;
            var k = giftRuleOf(l) + '|' + l.variant_id;
            var kept = sum(o.giftLines.filter(function (x) { return giftRuleOf(x) + '|' + x.variant_id === k; }), function (x) { return x.quantity; }) - r;
            blocked[k] = { s: sig, m: Math.max(0, kept) };
          });
          fix = { updates: up };
          return true;
        }
        if (o.charged && !readded[v]) {
          readded[v] = true;
          var line = o.giftLines.filter(function (l) { return l.final_line_price > 0 && giftRuleOf(l); })[0];
          if (line) {
            var up2 = {};
            up2[line.key] = 0;
            fix = { updates: up2, readd: { id: line.variant_id, quantity: line.quantity, properties: props(line) } };
            return true;
          }
        }
        return false;
      });
      if (fix) {
        changed = true;
        setBlocked(blocked);
        return Cart.update(fix.updates).then(function () {
          if (fix.readd) return Cart.add([fix.readd]).catch(function () {});
        }).then(Cart.get).then(function (c) { return step(c, n + 1); });
      }
      return Promise.resolve(cart);
    }

    return Cart.get().then(function (c) { return step(c, 0); }).then(function (cart) {
      return { cart: cart, changed: changed };
    });
  }

  function hasPubSub() { return typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'; }
  function announce(cart) {
    if (hasPubSub()) {
      try { window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vm-ofertas', cartData: cart }); } catch (e) { /* ignorar */ }
    }
    try { document.dispatchEvent(new CustomEvent('vm:cart:updated', { detail: { cart: cart } })); } catch (e) { /* ignorar */ }
  }

  /* ------------------------------------------------------------------ textos das ofertas */
  function giftValue(g, qty) { return (g.value || g.price || 0) * qty; }
  function giftNames(list) {
    return list.filter(function (x) { return x.qty > 0; }).map(function (x) { return x.qty + 'x ' + (x.g.title || 'Brinde'); }).join(' + ');
  }
  function ruleShort(r, list) {
    var q = list && list[0] ? list[0].qty : (r.gifts[0] ? r.gifts[0].qty : 1);
    if (r.short) return fill(r.short, { qtd: q });
    return 'Ganhe ' + giftNames(list) + ' de oferta';
  }

  function tierCfgFor(pid) {
    var tiers = null;
    var popular = 0;
    CFG.tiers.some(function (t) {
      if ((t.products || []).indexOf(pid) > -1) {
        tiers = parseTiers(t.tiers);
        popular = parseInt(t.popular, 10) || 0;
        return true;
      }
      return false;
    });
    if (!tiers || !tiers.length) {
      tiers = parseTiers(CFG.defaultTiers || '1,2,3');
      popular = parseInt(CFG.defaultPopular, 10) || 0;
    }
    if (!tiers.length) tiers = [1, 2];
    return { tiers: tiers.slice(0, 3), popular: popular };
  }

  function tierBenefits(pid, price, q) {
    var out = [];
    CFG.rules.forEach(function (r) {
      if (!r.on || r.products.indexOf(pid) < 0) return;
      if (q < r.min || (r.max && q > r.max)) return;
      var list = r.gifts.filter(function (g) { return g.available !== false; }).map(function (g) {
        return { g: g, qty: giftQtyFor(r, g, q) };
      }).filter(function (x) { return x.qty > 0; });
      if (list.length) out.push({ rule: r, list: list });
    });
    return { gifts: out, ship: FREE > 0 && price * q >= FREE };
  }

  /* ------------------------------------------------------------------ carrinho lateral */
  function shipHTML(cart) {
    if (!FREE) return '';
    var t = cart.total_price || 0;
    if (t >= FREE) {
      return '<div class="vmc-ship is-done"><p class="vmc-ship__t">' + ICON.truck + '<span>' + esc(CFG.freeShippingDone || 'Parabéns! Já tem portes grátis.') + '</span></p>' +
        '<div class="vmc-ship__bar" aria-hidden="true"><span class="vmc-ship__fill" style="width:100%"></span></div></div>';
    }
    var missing = FREE - t;
    var pct = Math.max(4, Math.min(100, Math.round((t / FREE) * 100)));
    var txt = esc(CFG.freeShippingText || 'Faltam [valor] para ter portes grátis').replace('[valor]', '<b>' + esc(money(missing)) + '</b>');
    return '<div class="vmc-ship"><p class="vmc-ship__t">' + ICON.truck + '<span>' + txt + '</span></p>' +
      '<div class="vmc-ship__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span class="vmc-ship__fill" style="width:' + pct + '%"></span></div></div>';
  }

  function nudgeHTML(s, need, more) {
    var r = s.rule;
    var target = s.inList[0];
    var needAll = r.gifts.map(function (g) { return { g: g, qty: r.scale ? Math.min(r.min, g.qty) : g.qty }; });
    var main = needAll[0] && needAll[0].g;
    var val2 = sum(needAll, function (x) { return giftValue(x.g, x.qty); });
    var msg = more
      ? 'Adicione mais ' + need + (need === 1 ? ' produto' : ' produtos') + ' e ganhe mais ' + giftNames(needAll) + ' grátis'
      : (r.nudge ? fill(r.nudge, { falta: need }) : ('Adicione mais ' + need + (need === 1 ? ' artigo' : ' artigos') + ' e ganhe ' + giftNames(needAll) + ' grátis'));
    var btnLabel = '+ Adicionar ' + (need === 1 ? 'mais 1' : 'mais ' + need) + (target ? ' · ' + shortTitle(target.product_title) : '');
    return '<div class="vmc-offer"><span class="vmc-offer__img">' + (main && main.image ? '<img src="' + esc(imgUrl(main.image, 140)) + '" alt="" loading="lazy" width="54" height="54">' : '') + '<span aria-hidden="true">🎁</span></span>' +
      '<span class="vmc-offer__txt"><span class="vmc-offer__t">' + esc(msg) + '</span>' +
      '<span class="vmc-offer__s">Oferta: ' + esc(giftNames(needAll)) + (val2 ? ' · valor ' + esc(money(val2)) : '') + '</span>' +
      '<span class="vmc-offer__acts">' + (target ? '<button type="button" class="vmc-offer__btn" data-vmc-inc="' + esc(target.key) + '" data-q="' + (target.quantity + need) + '">' + esc(btnLabel) + '</button>' : '') +
      (r.mode !== 'lista' || r.products.length > 1 ? '<a class="vmc-offer__link" href="' + esc(CFG.collectionUrl || (ROOT + 'collections/all')) + '">Ver outros produtos</a>' : '') + '</span></span></div>';
  }

  function offersHTML(cart, ev) {
    var won = [];
    var nudges = [];
    ev.status.forEach(function (s) {
      var r = s.rule;
      var list = s.gifts.length ? s.gifts : r.gifts.map(function (g) { return { g: g, qty: g.qty }; });
      var main = list[0] && list[0].g;
      if (!main) return;
      if (s.met) {
        var inCart = cart.items.some(function (i) { return giftRuleOf(i) === r.id && i.final_line_price === 0; }) ||
          cart.items.some(function (i) { return FREE_GIFT[i.variant_id] && list.some(function (x) { return x.g.variant === i.variant_id; }); });
        if (!inCart) return;
        var val = sum(list, function (x) { return giftValue(x.g, x.qty); });
        won.push('<div class="vmc-offer is-won"><span class="vmc-offer__img">' + (main.image ? '<img src="' + esc(imgUrl(main.image, 140)) + '" alt="" loading="lazy" width="54" height="54">' : '') + '<span aria-hidden="true">✓</span></span>' +
          '<span class="vmc-offer__txt"><span class="vmc-offer__t">Ganhou: ' + esc(giftNames(list)) + ' <em>grátis</em></span>' +
          '<span class="vmc-offer__s">' + esc(r.name || 'Oferta') + (val ? ' · valor ' + esc(money(val)) : '') + '</span></span></div>');
        if (s.next > 0 && nudges.length < 2) nudges.push(nudgeHTML(s, s.next, true));
      } else if (s.listQty > 0 && s.need > 0 && !s.over && nudges.length < 2) {
        nudges.push(nudgeHTML(s, s.need, false));
      }
    });
    if (!won.length && !nudges.length) return '';
    return '<div class="vmc-offers">' + nudges.join('') + won.join('') + '</div>';
  }

  function itemHTML(i) {
    var gift = isGift(i);
    var rule = RULE_BY_ID[giftRuleOf(i)];
    var free = i.final_line_price === 0;
    var giftCfg = null;
    if (gift) {
      CFG.rules.some(function (r) { return r.gifts.some(function (g) { if (g.variant === i.variant_id) { giftCfg = g; return true; } return false; }); });
    }
    var variant = i.variant_title && i.variant_title !== 'Default Title' && !i.product_has_only_default_variant ? i.variant_title : '';
    var tags = '';
    if (gift) tags += '<span class="vmc-tag">' + ICON.gift + ' Oferta</span>';
    if (!gift) {
      (i.line_level_discount_allocations || []).forEach(function (a) {
        if (a.amount > 0) tags += '<span class="vmc-tag vmc-tag--disc">−' + esc(money(a.amount)) + ' · ' + esc((a.discount_application && a.discount_application.title) || 'Desconto') + '</span>';
      });
    }
    var price;
    if (free) {
      var val = giftCfg ? giftValue(giftCfg, i.quantity) : i.original_line_price;
      price = (val ? '<s>' + esc(money(val)) + '</s>' : '') + '<span class="is-free">Grátis</span>';
    } else {
      price = (i.original_line_price > i.final_line_price ? '<s>' + esc(money(i.original_line_price)) + '</s>' : '') + '<span>' + esc(money(i.final_line_price)) + '</span>';
    }
    var qty = gift
      ? '<span class="vmc-item__gift">' + esc(i.quantity + (i.quantity === 1 ? ' unidade' : ' unidades')) + (rule && rule.name ? ' · ' + esc(rule.name) : '') + '</span>'
      : '<div class="vmc-qty"><button type="button" data-vmc-q="' + esc(i.key) + '" data-q="' + (i.quantity - 1) + '" aria-label="Diminuir quantidade">−</button><span aria-label="Quantidade">' + i.quantity + '</span><button type="button" data-vmc-q="' + esc(i.key) + '" data-q="' + (i.quantity + 1) + '" aria-label="Aumentar quantidade">+</button></div>';
    return '<li class="vmc-item' + (gift ? ' vmc-item--gift' : '') + '">' +
      '<a class="vmc-item__img" href="' + esc(gift && giftCfg && giftCfg.image ? '#' : i.url) + '"' + (gift ? ' tabindex="-1" aria-hidden="true"' : '') + '>' + ((gift && giftCfg && giftCfg.image) || i.image ? '<img src="' + esc(imgUrl((gift && giftCfg && giftCfg.image) || i.image, 180)) + '" alt="" loading="lazy" width="72" height="72">' : '') + '</a>' +
      '<div class="vmc-item__main"><div class="vmc-item__top">' + (gift ? '<span class="vmc-item__title">' + esc((giftCfg && giftCfg.title) || shortTitle(i.product_title)) + '</span>' : '<a class="vmc-item__title" href="' + esc(i.url) + '">' + esc(shortTitle(i.product_title)) + '</a>') +
      (gift ? '' : '<button type="button" class="vmc-item__rm" data-vmc-q="' + esc(i.key) + '" data-q="0" aria-label="Remover ' + esc(shortTitle(i.product_title)) + '">' + ICON.x + '</button>') + '</div>' +
      (variant ? '<span class="vmc-item__var">' + esc(variant) + '</span>' : '') +
      (tags ? '<div class="vmc-item__tags">' + tags + '</div>' : '') +
      '<div class="vmc-item__row">' + qty + '<span class="vmc-item__price">' + price + '</span></div></div></li>';
  }

  function upsellList(cart, ev) {
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var out = [];
    CFG.cross.forEach(function (c) {
      if (out.length >= 2 || !c.offer || c.offer.available === false || inCart[c.offer.product]) return;
      if (out.some(function (o) { return o.offer.product === c.offer.product; })) return;
      if (ev.paid.some(function (i) { return (c.products || []).indexOf(i.product_id) > -1; })) out.push(c);
    });
    if (!out.length) {
      CFG.bestsellers.forEach(function (b) {
        if (out.length >= 2 || inCart[b.product] || b.available === false || !b.variant) return;
        out.push({ title: 'Sugestões para si', note: '', offer: b });
      });
    }
    return out;
  }

  function upsellHTML(list, title) {
    if (!list.length) return '';
    return '<div class="vmc-ups"><p class="vmc-ups__t">' + esc(title || list[0].title || 'Quem comprou também levou') + '</p><ul class="vmc-ups__list">' +
      list.map(function (c) {
        var o = c.offer;
        return '<li class="vmc-up">' + (o.image ? '<img src="' + esc(imgUrl(o.image, 120)) + '" alt="" loading="lazy" width="48" height="48">' : '') +
          '<span class="vmc-up__info"><a class="vmc-up__name" href="' + esc(o.url) + '">' + esc(shortTitle(o.title)) + '</a><span class="vmc-up__price">' + esc(money(o.price)) + '</span>' +
          (c.note ? '<span class="vmc-up__note">' + esc(c.note) + '</span>' : '') + '</span>' +
          '<button type="button" class="vmc-up__add" data-vmc-add="' + o.variant + '">+ Adicionar</button></li>';
      }).join('') + '</ul></div>';
  }

  function sumHTML(cart) {
    var freeGiftVal = 0;
    cart.items.forEach(function (i) {
      if (FREE_GIFT[i.variant_id] && i.original_line_price === 0) {
        CFG.rules.some(function (r) { return r.gifts.some(function (g) { if (g.variant === i.variant_id) { freeGiftVal += giftValue(g, i.quantity); return true; } return false; }); });
      }
    });
    var saving = (cart.total_discount || 0) + freeGiftVal;
    var shipFree = FREE && cart.total_price >= FREE;
    var notice = CFG.cartNotice ? '<p class="vmc-notice" role="note">' + esc(CFG.cartNotice) + '</p>' : '';
    return notice + '<div class="vmc-sum">' +
      '<div class="vmc-sum__row"><span>Subtotal</span><b>' + esc(money(cart.original_total_price)) + '</b></div>' +
      (cart.total_discount > 0 ? '<div class="vmc-sum__row vmc-sum__save"><span>Ofertas e descontos</span><b>−' + esc(money(cart.total_discount)) + '</b></div>' : '') +
      '<div class="vmc-sum__row"><span>Portes</span><b>' + (shipFree ? 'Grátis' : 'Calculados no checkout') + '</b></div>' +
      '<div class="vmc-sum__row vmc-sum__total"><span>Total<small>IVA incluído</small></span><span>' + esc(money(cart.total_price)) + '</span></div>' +
      (saving > 0 ? '<div class="vmc-sum__row vmc-sum__save"><span>' + ICON.gift + ' Está a poupar ' + esc(money(saving)) + ' nesta encomenda</span></div>' : '') +
      '</div>' +
      '<a class="vmc-checkout" href="' + esc(ROOT + 'checkout') + '">' + ICON.lock + ' Finalizar compra</a>' +
      '<div class="vmc-links"><button type="button" data-vmc-close>Continuar a comprar</button><a href="' + esc(CFG.cartUrl || (ROOT + 'cart')) + '">Ver carrinho</a></div>';
  }

  function emptyHTML() {
    var list = CFG.bestsellers.filter(function (b) { return b.available !== false && b.variant; }).slice(0, 3).map(function (b) { return { offer: b, note: '' }; });
    return '<div class="vmc-empty"><p class="vmc-empty__t">O seu carrinho está vazio</p><p class="vmc-empty__s">Descubra as nossas soluções para o seu bem-estar.</p>' +
      '<a class="vmc-empty__btn" href="' + esc(CFG.collectionUrl || (ROOT + 'collections/all')) + '">Ver produtos</a></div>' +
      upsellHTML(list, 'Os mais procurados');
  }

  var drawerEl = null;
  function getDrawer() {
    if (drawerEl && drawerEl.isConnected) return drawerEl;
    drawerEl = document.querySelector('cart-drawer.vmc');
    return drawerEl;
  }

  function VmCartDrawerFactory() {
    return class VmCartDrawer extends HTMLElement {
      connectedCallback() {
        if (this.parentNode !== document.body) { document.body.appendChild(this); return; }
        if (this.__ready) return;
        this.__ready = true;
        this.panel = this.querySelector('.vmc__panel');
        this.bodyEl = this.querySelector('[data-vmc-body]');
        this.footEl = this.querySelector('[data-vmc-foot]');
        this.countEl = this.querySelector('[data-vmc-count]');
        this.liveEl = this.querySelector('[data-vmc-live]');
        this.onKey = this.onKey.bind(this);
        this.addEventListener('click', this.onClick.bind(this));
      }
      /* compatibilidade com o product-form do Dawn */
      getSectionsToRender() { return [{ id: 'cart-icon-bubble' }]; }
      setActiveElement(el) { this.trigger = el; }
      renderContents() {
        var self = this;
        return reconcile().then(function (res) { self.render(res.cart); announce(res.cart); self.open(self.trigger); });
      }
      refresh() {
        var self = this;
        return Cart.get().then(function (c) { self.render(c); return c; });
      }
      render(cart) {
        if (!cart || !this.bodyEl) return;
        this.cart = cart;
        var ev = evaluate(cart);
        if (this.countEl) this.countEl.textContent = cart.item_count ? String(cart.item_count) : '';
        if (!cart.item_count) {
          this.bodyEl.innerHTML = emptyHTML();
          this.footEl.hidden = true;
          this.footEl.innerHTML = '';
          return;
        }
        var paid = cart.items.filter(function (i) { return !isGift(i); });
        var gifts = cart.items.filter(function (i) { return isGift(i); });
        this.bodyEl.innerHTML = shipHTML(cart) + offersHTML(cart, ev) +
          '<ul class="vmc-items">' + paid.map(itemHTML).join('') + gifts.map(itemHTML).join('') + '</ul>' +
          upsellHTML(upsellList(cart, ev));
        this.footEl.innerHTML = sumHTML(cart);
        this.footEl.hidden = false;
      }
      open(trigger) {
        if (trigger && trigger.nodeType === 1) this.trigger = trigger;
        if (!this.cart) this.refresh();
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('vmc-open');
        document.addEventListener('keydown', this.onKey);
        var panel = this.panel;
        window.setTimeout(function () { if (panel) panel.focus({ preventScroll: true }); }, 60);
      }
      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('vmc-open');
        document.removeEventListener('keydown', this.onKey);
        if (this.trigger && this.trigger.focus && document.contains(this.trigger)) {
          try { this.trigger.focus({ preventScroll: true }); } catch (e) { /* ignorar */ }
        }
      }
      onKey(e) {
        if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
        if (e.key !== 'Tab') return;
        var items = Array.prototype.filter.call(this.panel.querySelectorAll('a[href],button:not([disabled]),input,select'), function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; });
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      busy(on) { if (this.panel) this.panel.classList.toggle('is-busy', !!on); }
      say(msg) { if (this.liveEl) this.liveEl.textContent = msg || ''; }
      act(promise, msg) {
        var self = this;
        this.busy(true);
        return promise.then(function () { return reconcile(); }).then(function (res) {
          self.render(res.cart);
          announce(res.cart);
          self.say(msg || 'Carrinho atualizado');
        }).catch(function (err) {
          self.say(err && err.message);
          return self.refresh().then(function () {
            var box = document.createElement('p');
            box.className = 'vmh-err';
            box.setAttribute('role', 'alert');
            box.textContent = (err && err.message) || 'Não foi possível atualizar o carrinho.';
            self.bodyEl.insertBefore(box, self.bodyEl.firstChild);
          });
        }).then(function () { self.busy(false); });
      }
      onClick(e) {
        var t = e.target.closest('[data-vmc-close],[data-vmc-q],[data-vmc-inc],[data-vmc-add]');
        if (!t || !this.contains(t)) return;
        if (t.hasAttribute('data-vmc-close')) { e.preventDefault(); this.close(); return; }
        e.preventDefault();
        if (this.panel && this.panel.classList.contains('is-busy')) return;
        if (t.hasAttribute('data-vmc-q')) {
          var q = Math.max(0, parseInt(t.getAttribute('data-q'), 10) || 0);
          this.act(Cart.change(t.getAttribute('data-vmc-q'), q), q === 0 ? 'Artigo removido' : 'Quantidade atualizada');
        } else if (t.hasAttribute('data-vmc-inc')) {
          this.act(Cart.change(t.getAttribute('data-vmc-inc'), parseInt(t.getAttribute('data-q'), 10) || 1), 'Artigo adicionado');
        } else if (t.hasAttribute('data-vmc-add')) {
          this.act(Cart.add([{ id: parseInt(t.getAttribute('data-vmc-add'), 10), quantity: 1 }]), 'Artigo adicionado');
        }
      }
    };
  }

  function openCart(trigger, cart) {
    var d = getDrawer();
    if (d && typeof d.open === 'function' && CFG.drawer !== false) {
      if (cart) d.render(cart);
      d.open(trigger);
      return true;
    }
    window.location.href = CFG.cartUrl || (ROOT + 'cart');
    return false;
  }

  /* ------------------------------------------------------------------ página do carrinho */
  function initCartPage() {
    if (!IS_CART_PAGE) return;
    var items = document.querySelector('cart-items');
    if (!items) return;
    var host = document.createElement('div');
    host.className = 'vm-root vmc vmc-page';
    items.parentNode.insertBefore(host, items);
    var last = null;
    function mark(cart) {
      cart.items.forEach(function (i, idx) {
        var row = document.getElementById('CartItem-' + (idx + 1));
        if (!row) return;
        var gift = isGift(i);
        row.classList.toggle('vmc-gift-row', gift);
        var details = row.querySelector('.cart-item__details') || row;
        var badge = details.querySelector('.vmc-gift-badge');
        if (gift && !badge) {
          badge = document.createElement('span');
          badge.className = 'vmc-gift-badge';
          badge.innerHTML = ICON.gift + ' Oferta';
          details.appendChild(badge);
        } else if (!gift && badge) {
          badge.remove();
        }
      });
    }
    function render(cart) {
      last = cart;
      host.innerHTML = cart.item_count ? shipHTML(cart) + offersHTML(cart, evaluate(cart)) : '';
      mark(cart);
    }
    Cart.get().then(render).catch(function () {});
    document.addEventListener('vm:cart:updated', function (e) { if (e.detail && e.detail.cart) render(e.detail.cart); });
    if ('MutationObserver' in window) {
      new MutationObserver(function () { if (last) mark(last); }).observe(items, { childList: true, subtree: true });
    }
    host.addEventListener('click', function (e) {
      var t = e.target.closest('[data-vmc-inc]');
      if (!t) return;
      e.preventDefault();
      t.disabled = true;
      Cart.change(t.getAttribute('data-vmc-inc'), parseInt(t.getAttribute('data-q'), 10) || 1)
        .then(function () { return reconcile(); })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    });
  }

  /* ------------------------------------------------------------------ página do produto */
  function initHero(root) {
    if (root.__vmh) return;
    root.__vmh = true;
    var form = root.querySelector('[data-vmh-form]');
    if (!form) return;
    var grid = root.querySelector('[data-vmh-grid]');
    var giftBox = root.querySelector('[data-vmh-gift]');
    var crossBox = root.querySelector('[data-vmh-cross]');
    var btn = root.querySelector('[data-vmh-buy]');
    var sumEl = root.querySelector('[data-vmh-sum]');
    var labelEl = root.querySelector('[data-vmh-label]');
    var priceEl = root.querySelector('[data-vmh-price]');
    var trustEl = root.querySelector('[data-vmh-trust]');
    var errEl = root.querySelector('.vmh-err');
    var variantSel = root.querySelector('[data-vmh-variant]');
    var pid = parseInt(root.getAttribute('data-product'), 10);
    var name = root.getAttribute('data-name') || '';
    var uid = root.id || ('vmh-' + pid);
    var st = {
      vid: parseInt(root.getAttribute('data-variant'), 10),
      price: parseInt(root.getAttribute('data-price'), 10) || 0,
      compare: parseInt(root.getAttribute('data-compare'), 10) || 0,
      available: root.getAttribute('data-available') === 'true',
      q: 1,
      cross: null,
      crossOn: false
    };
    var packN = parseInt(root.getAttribute('data-pack-n'), 10) || 0;
    var packW = root.getAttribute('data-pack-w') || '';
    var days = parseInt(root.getAttribute('data-days'), 10) || 0;
    var unit1 = root.getAttribute('data-unit1') || '1 embalagem';
    var unitN = root.getAttribute('data-unitn') || '[n] embalagens';
    var tc = tierCfgFor(pid);

    function unitText(q) {
      if (packN) {
        var months = days ? Math.round((q * days) / 30) : 0;
        return (packN * q) + ' ' + packW + (months ? ' · ' + months + (months === 1 ? ' mês' : ' meses') : '');
      }
      return q === 1 ? unit1 : unitN.replace('[n]', q);
    }

    var popular = tc.popular && tc.tiers.indexOf(tc.popular) > -1 ? tc.popular : 0;
    if (!popular) {
      tc.tiers.some(function (q) { if (tierBenefits(pid, st.price, q).gifts.length) { popular = q; return true; } return false; });
    }
    if (!popular) popular = tc.tiers.length > 1 ? tc.tiers[1] : tc.tiers[0];
    st.q = popular;

    function optionHTML(q) {
      var b = tierBenefits(pid, st.price, q);
      var lines = b.gifts.map(function (x) { return '<span class="vmh-opt__g">' + ICON.gift + ' ' + esc(ruleShort(x.rule, x.list)) + '</span>'; }).join('');
      if (b.ship) lines += '<span class="vmh-opt__f">' + ICON.truck.replace(/width="18" height="18"/, 'width="14" height="14"') + 'Portes grátis</span>';
      return '<label class="vmh-opt' + (q === st.q ? ' is-active' : '') + '">' +
        (q === popular && tc.tiers.length > 1 ? '<span class="vmh-badge">' + esc(CFG.popularLabel || 'Mais popular') + '</span>' : '') +
        '<input type="radio" name="' + esc(uid) + '-q" value="' + q + '"' + (q === st.q ? ' checked' : '') + '>' +
        '<span class="vmh-opt__t">Compre ' + q + '</span>' +
        '<span class="vmh-opt__s">' + esc(unitText(q)) + '</span>' + lines +
        '<span class="vmh-opt__p">' + (st.compare > st.price ? '<s>' + esc(money(st.compare * q)) + '</s>' : '') + esc(money(st.price * q)) + '</span></label>';
    }

    function renderTiers() {
      grid.innerHTML = tc.tiers.map(optionHTML).join('');
      grid.className = 'vmh-grid vmh-grid--' + Math.min(3, tc.tiers.length);
      grid.removeAttribute('data-pending');
    }

    function renderGift() {
      if (!giftBox) return;
      var sel = tierBenefits(pid, st.price, st.q);
      var html = '';
      var off = false;
      var pick = null;
      if (sel.gifts.length) {
        var all = [];
        sel.gifts.forEach(function (x) { all = all.concat(x.list); });
        var val = sum(all, function (x) { return giftValue(x.g, x.qty); });
        var img = all[0].g.image;
        html = (img ? '<img src="' + esc(imgUrl(img, 160)) + '" alt="" width="58" height="58" loading="lazy">' : '') +
          '<span class="vmh-gift__txt"><span class="vmh-gift__t">' + esc(giftNames(all)) + ' de <em>oferta</em>!</span>' +
          '<span class="vmh-gift__s">Incluído na opção Compre ' + st.q + (val ? ' · no valor de ' + esc(money(val)) : '') + '. Adicionado automaticamente ao carrinho.</span></span>';
      } else {
        tc.tiers.some(function (q) { if (q > st.q && tierBenefits(pid, st.price, q).gifts.length) { pick = q; return true; } return false; });
        if (pick) {
          var b = tierBenefits(pid, st.price, pick);
          var all2 = [];
          b.gifts.forEach(function (x) { all2 = all2.concat(x.list); });
          var val2 = sum(all2, function (x) { return giftValue(x.g, x.qty); });
          off = true;
          html = (all2[0].g.image ? '<img src="' + esc(imgUrl(all2[0].g.image, 160)) + '" alt="" width="58" height="58" loading="lazy">' : '') +
            '<span class="vmh-gift__txt"><span class="vmh-gift__t">Escolha Compre ' + pick + ' e receba ' + esc(giftNames(all2)) + ' <em>grátis</em></span>' +
            '<span class="vmh-gift__s">' + (val2 ? 'Oferta no valor de ' + esc(money(val2)) + ' · ' : '') + 'toque para escolher</span></span>';
        }
      }
      giftBox.innerHTML = html;
      giftBox.hidden = !html;
      giftBox.classList.toggle('is-off', off);
      giftBox.setAttribute('data-pick', pick || '');
    }

    function renderCross() {
      if (!crossBox) return;
      var c = null;
      CFG.cross.some(function (x) {
        if (x.offer && x.offer.available !== false && x.offer.product !== pid && (x.products || []).indexOf(pid) > -1) { c = x; return true; }
        return false;
      });
      st.cross = c;
      if (!c) { crossBox.hidden = true; return; }
      var o = c.offer;
      crossBox.innerHTML = '<p class="vmh-cross__t">' + esc(c.title || 'Quem comprou também levou') + '</p>' +
        '<label class="vmh-cross__card' + (st.crossOn ? ' is-on' : '') + '"><input type="checkbox" data-vmh-cross-on' + (st.crossOn ? ' checked' : '') + '>' +
        (o.image ? '<img src="' + esc(imgUrl(o.image, 120)) + '" alt="" width="46" height="46" loading="lazy">' : '') +
        '<span class="vmh-cross__info"><span class="vmh-cross__name">Adicionar ' + esc(shortTitle(o.title)) + '</span>' +
        (c.note ? '<span class="vmh-cross__note">' + esc(c.note) + '</span>' : '') + '</span>' +
        '<span class="vmh-cross__price">+' + esc(money(o.price)) + '</span></label>';
      crossBox.hidden = false;
    }

    function totalNow() { return st.price * st.q + (st.crossOn && st.cross ? st.cross.offer.price : 0); }

    var sticky = null;
    var entrega = null;
    var stT = null;
    var stP = null;
    var stB = null;

    function sync() {
      Array.prototype.forEach.call(grid.querySelectorAll('input[type="radio"]'), function (r) {
        var l = r.closest('.vmh-opt');
        if (l) l.classList.toggle('is-active', r.checked);
      });
      root.setAttribute('data-sel', String(st.q));
      if (sumEl) sumEl.textContent = '· ' + money(totalNow());
      if (priceEl) priceEl.textContent = money(st.price);
      if (labelEl) labelEl.textContent = st.available ? 'Adicionar ao carrinho' : 'Esgotado';
      if (btn) btn.disabled = !st.available;
      if (stT) stT.textContent = 'Compre ' + st.q + ' · ' + name;
      if (stP) stP.textContent = money(totalNow());
      if (stB) stB.disabled = !st.available;
      renderGift();
      if (entrega) entrega.refresh();
    }

    grid.addEventListener('change', function (e) {
      if (e.target && e.target.name === uid + '-q') { st.q = parseInt(e.target.value, 10) || 1; sync(); }
    });
    if (giftBox) giftBox.addEventListener('click', function () {
      var p = parseInt(giftBox.getAttribute('data-pick'), 10);
      if (!p) return;
      st.q = p;
      var r = grid.querySelector('input[value="' + p + '"]');
      if (r) r.checked = true;
      sync();
    });
    if (crossBox) crossBox.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute('data-vmh-cross-on')) {
        st.crossOn = e.target.checked;
        var card = e.target.closest('.vmh-cross__card');
        if (card) card.classList.toggle('is-on', st.crossOn);
        sync();
      }
    });
    if (variantSel) variantSel.addEventListener('change', function () {
      var o = variantSel.options[variantSel.selectedIndex];
      st.vid = parseInt(o.value, 10);
      st.price = parseInt(o.getAttribute('data-price'), 10) || 0;
      st.compare = parseInt(o.getAttribute('data-compare'), 10) || 0;
      st.available = o.getAttribute('data-available') === 'true';
      renderTiers();
      sync();
    });
    if (trustEl && FREE) trustEl.textContent = 'Portes grátis em compras a partir de ' + moneyShort(FREE);

    function reset() {
      if (btn) { btn.classList.remove('is-loading'); btn.disabled = !st.available; }
      if (stB) stB.disabled = !st.available;
    }
    window.addEventListener('pageshow', reset);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!st.available || (btn && btn.classList.contains('is-loading'))) return;
      var items = [{ id: st.vid, quantity: st.q }];
      if (st.crossOn && st.cross) items.push({ id: st.cross.offer.variant, quantity: 1 });
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
      if (stB) stB.disabled = true;
      if (errEl) errEl.hidden = true;
      Cart.add(items).then(function () { return reconcile(); }).then(function (res) {
        announce(res.cart);
        reset();
        openCart(btn, res.cart);
      }).catch(function (err) {
        reset();
        if (errEl) {
          errEl.textContent = (err && err.message) || 'Não foi possível adicionar o produto. Tente novamente.';
          errEl.hidden = false;
        }
      });
    });

    renderTiers();
    renderCross();
    sync();

    // barra fixa (só no bloco do topo)
    if (root.getAttribute('data-local') === 'hero') {
      var wrap = root.parentNode;
      sticky = wrap ? wrap.querySelector('[data-vmh-sticky]') : null;
      if (sticky) {
        Array.prototype.forEach.call(document.querySelectorAll('body > [data-vmh-sticky]'), function (x) { if (x !== sticky) x.remove(); });
        document.body.appendChild(sticky);
        stT = sticky.querySelector('[data-vmh-st-t]');
        stP = sticky.querySelector('[data-vmh-st-p]');
        stB = sticky.querySelector('[data-vmh-st-btn]');
        if (stB) stB.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else if (btn) btn.click();
        });
        if (btn) {
          // mostra a barra quando o botão principal já ficou para cima (funciona também com saltos de scroll)
          var stOn = null;
          var stTick = false;
          var stUpd = function () {
            stTick = false;
            var r = btn.getBoundingClientRect();
            var past = (r.width > 0 || r.height > 0) && r.bottom < 0;
            if (past === stOn) return;
            stOn = past;
            sticky.classList.toggle('is-on', past);
            sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
            if (stB) stB.tabIndex = past ? 0 : -1;
          };
          var stReq = function () {
            if (stTick) return;
            stTick = true;
            if (window.requestAnimationFrame) window.requestAnimationFrame(stUpd); else setTimeout(stUpd, 60);
          };
          window.addEventListener('scroll', stReq, { passive: true });
          window.addEventListener('resize', stReq);
          window.addEventListener('pageshow', stReq);
          stUpd();
        }
        sync();
      }
      entrega = initEntrega(root, totalNow);
      dots(root);
    }
  }

  /* ------------------------------------------------------------------ prazo de entrega (página do produto)
     Datas em dias úteis de Portugal (sem fins de semana nem feriados nacionais), hora de Lisboa.
     Os portes grátis seguem o mesmo valor mínimo da regra de envio da loja. */
  var ENT = CFG.entrega && typeof CFG.entrega === 'object' ? CFG.entrega : null;
  var ZIP_KEY = 'vmCodigoPostal';
  var DAY = 86400000;
  var WD = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
  var MO = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
  var HOL = {};
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function isoDay(d) { return d.getUTCFullYear() + '-' + pad2(d.getUTCMonth() + 1) + '-' + pad2(d.getUTCDate()); }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var n = h + l - 7 * m + 114;
    return Date.UTC(y, Math.floor(n / 31) - 1, (n % 31) + 1);
  }
  function holidays(y) {
    if (HOL[y]) return HOL[y];
    var set = {};
    ['01-01', '04-25', '05-01', '06-10', '08-15', '10-05', '11-01', '12-01', '12-08', '12-25'].forEach(function (md) { set[y + '-' + md] = true; });
    var e = easter(y);
    [-2, 0, 60].forEach(function (o) { set[isoDay(new Date(e + o * DAY))] = true; }); // Sexta-feira Santa, Páscoa, Corpo de Deus
    HOL[y] = set;
    return set;
  }
  function isBizDay(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && !holidays(d.getUTCFullYear())[isoDay(d)]; }
  function nextBiz(d) { var x = new Date(d.getTime() + DAY); while (!isBizDay(x)) x = new Date(x.getTime() + DAY); return x; }
  function addBiz(d, n) { var x = d; for (var i = 0; i < n; i++) x = nextBiz(x); return x; }
  function lisbonNow() {
    var now = new Date();
    try {
      var o = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Lisbon', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
        .formatToParts(now).forEach(function (p) { o[p.type] = p.value; });
      if (o.year && o.month && o.day) return { y: +o.year, m: +o.month, d: +o.day, h: (+o.hour || 0) % 24 };
    } catch (e) { /* sem Intl com fusos horários */ }
    return { y: now.getFullYear(), m: now.getMonth() + 1, d: now.getDate(), h: now.getHours() };
  }
  function dayLabel(d, withMonth) { return WD[d.getUTCDay()] + ', ' + d.getUTCDate() + (withMonth ? ' de ' + MO[d.getUTCMonth()] : ''); }
  function rangeLabel(a, b) {
    if (isoDay(a) === isoDay(b)) return dayLabel(a, true);
    var same = a.getUTCMonth() === b.getUTCMonth() && a.getUTCFullYear() === b.getUTCFullYear();
    return 'entre ' + dayLabel(a, !same) + ' e ' + dayLabel(b, true);
  }
  function parseZip(v) {
    var digits = String(v || '').replace(/\D/g, '');
    if (digits.length !== 4 && digits.length !== 7) return { ok: false, digits: digits };
    var cp4 = parseInt(digits.slice(0, 4), 10);
    var region = null;
    (ENT.regions || []).some(function (r) { if (cp4 >= r.from && cp4 <= r.to) { region = r; return true; } return false; });
    return { ok: !!region, digits: digits, region: region, label: digits.length === 7 ? digits.slice(0, 4) + '-' + digits.slice(4) : digits };
  }
  function estimate(region) {
    var now = lisbonNow();
    var today = new Date(Date.UTC(now.y, now.m - 1, now.d));
    var cutoff = parseInt(ENT.cutoff, 10);
    if (isNaN(cutoff)) cutoff = 14;
    var start = isBizDay(today) && cutoff > 0 && now.h < cutoff ? today : nextBiz(today);
    var min = Math.max(0, parseInt(region.min, 10) || 0);
    var max = Math.max(min, parseInt(region.max, 10) || min);
    return { from: addBiz(start, min), to: addBiz(start, max), min: min, max: max, sameDay: start === today };
  }

  function initEntrega(root, totalNow) {
    var box = root.querySelector('[data-vm-entrega]');
    if (!box || box.__vm || !ENT || ENT.enabled === false || !Array.isArray(ENT.regions) || !ENT.regions.length) return null;
    box.__vm = true;
    var toggle = box.querySelector('[data-vm-entrega-toggle]');
    var panel = box.querySelector('.vmh-ship__panel');
    var form = box.querySelector('[data-vm-entrega-form]');
    var input = box.querySelector('[data-vm-entrega-zip]');
    var out = box.querySelector('[data-vm-entrega-result]');
    if (!form || !input || !out) return null;
    var cartTotal = null;
    var last = null;

    function open(on) {
      if (!panel || !toggle) return;
      panel.hidden = !on;
      toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      box.classList.toggle('is-open', on);
    }
    function costHTML() {
      if (!FREE) return '';
      var total = (cartTotal || 0) + (typeof totalNow === 'function' ? totalNow() : 0);
      if (total >= FREE) return '<p class="vmh-ship__cost is-free">' + ICON.truck + '<span><strong>Portes grátis</strong> nesta encomenda</span></p>';
      return '<p class="vmh-ship__cost">' + ICON.truck + '<span>Portes grátis a partir de ' + esc(moneyShort(FREE)) + ' · faltam <strong>' + esc(money(FREE - total)) + '</strong></span></p>';
    }
    function render() {
      if (!last) return;
      if (!last.ok) {
        var msg = last.digits.length === 5 || last.digits.length > 7
          ? 'Enviamos apenas para Portugal. Introduza um código postal português (ex.: 1000-001).'
          : 'Introduza um código postal português válido (ex.: 1000-001).';
        out.innerHTML = '<p class="vmh-ship__err">' + esc(msg) + '</p>';
        return;
      }
      var e = estimate(last.region);
      var days = e.min === e.max ? e.max + (e.max === 1 ? ' dia útil' : ' dias úteis') : e.min + ' a ' + e.max + ' dias úteis';
      out.innerHTML = '<div class="vmh-ship__ok">' +
        '<p class="vmh-ship__when"><span class="vmh-ship__lbl">Entrega estimada</span><strong>' + esc(rangeLabel(e.from, e.to)) + '</strong></p>' +
        '<p class="vmh-ship__meta">' + esc(last.region.name) + ' · ' + esc(days) + ' · ' + esc(last.label) + '</p>' +
        costHTML() +
        (ENT.note ? '<p class="vmh-ship__note">' + esc(ENT.note) + '</p>' : '') +
        '</div>';
    }
    function calc(save) {
      last = parseZip(input.value);
      if (last.ok) {
        input.value = last.label;
        input.removeAttribute('aria-invalid');
        if (save) { try { window.localStorage.setItem(ZIP_KEY, last.label); } catch (err) { /* sem armazenamento */ } }
        if (cartTotal === null) {
          cartTotal = 0;
          Cart.get().then(function (cart) { cartTotal = (cart && cart.total_price) || 0; render(); }).catch(function () { /* ignorar */ });
        }
      } else {
        input.setAttribute('aria-invalid', 'true');
      }
      render();
    }

    if (toggle) toggle.addEventListener('click', function () {
      var on = panel ? panel.hidden : true;
      open(on);
      if (on) { try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); } }
    });
    input.addEventListener('input', function () {
      var d = input.value.replace(/\D/g, '').slice(0, 7);
      var v = d.length > 4 ? d.slice(0, 4) + '-' + d.slice(4) : d;
      if (v !== input.value) input.value = v;
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); calc(true); });
    document.addEventListener('vm:cart:updated', function (ev) {
      var c = ev && ev.detail && ev.detail.cart;
      if (c && typeof c.total_price === 'number') { cartTotal = c.total_price; render(); }
    });

    box.hidden = false;
    var saved = '';
    try { saved = window.localStorage.getItem(ZIP_KEY) || ''; } catch (err) { saved = ''; }
    if (saved && parseZip(saved).ok) { input.value = saved; open(true); calc(false); }

    return { refresh: render };
  }

  function dots(root) {
    var product = root.closest('.product');
    var list = product && product.querySelector('.product__media-list');
    if (!list || document.querySelector('.vmh-dots')) return;
    var slides = Array.prototype.filter.call(list.children, function (s) { return s.classList && s.classList.contains('product__media-item'); });
    if (slides.length < 2) return;
    var wrap = document.createElement('div');
    wrap.className = 'vmh-dots';
    wrap.setAttribute('aria-hidden', 'true');
    slides.forEach(function (s, i) { var d = document.createElement('span'); d.className = 'vmh-dot' + (i === 0 ? ' is-on' : ''); wrap.appendChild(d); });
    var anchor = list.closest('slider-component') || list;
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    var ticking = false;
    list.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var w = list.clientWidth || 1;
        var i = Math.max(0, Math.min(slides.length - 1, Math.round(list.scrollLeft / w)));
        Array.prototype.forEach.call(wrap.children, function (d, k) { d.classList.toggle('is-on', k === i); });
      });
    }, { passive: true });
  }

  /* ------------------------------------------------------------------ pesquisa inteligente */
  var NEEDS = CFG.needs.map(function (n) {
    return { n: n, keys: parseList(n.keys).map(norm).filter(function (k) { return k.length >= 3; }) };
  }).filter(function (x) { return x.n && x.n.product && x.keys.length; });

  function matchNeeds(q) {
    var nq = norm(q).trim();
    if (nq.length < 3) return [];
    var words = nq.split(/[^a-z0-9]+/).filter(function (w) { return w.length >= 3; });
    var out = [];
    NEEDS.forEach(function (x) {
      var hit = x.keys.some(function (k) {
        if (k.indexOf(' ') > -1) return nq.indexOf(k) > -1;
        return words.some(function (w) { return w.indexOf(k) === 0 || (w.length >= 4 && k.indexOf(w) === 0); });
      });
      if (hit && !out.some(function (o) { return o.n.product.handle === x.n.product.handle; })) out.push(x);
    });
    return out.slice(0, 3);
  }

  function recoHTML(list, q) {
    return '<p class="vms-reco__t">Sugestão para «' + esc(q.trim()) + '»</p><ul class="vms-reco__list">' + list.map(function (x) {
      var p = x.n.product;
      return '<li><a class="vms-card" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(imgUrl(p.image, 120)) + '" alt="" width="52" height="52" loading="lazy">' : '') +
        '<span class="vms-card__info"><span class="vms-card__need">' + esc(x.n.label) + '</span><span class="vms-card__name">' + esc(shortTitle(p.title)) + '</span>' +
        (p.price ? '<span class="vms-card__price">' + esc(money(p.price)) + '</span>' : '') + '</span><span class="vms-card__go">Ver →</span></a></li>';
    }).join('') + '</ul>';
  }

  function initSearch() {
    if (CFG.search === false || !NEEDS.length) return;
    var seen = {};
    var chips = NEEDS.filter(function (x) {
      var k = x.n.label;
      if (seen[k]) return false;
      seen[k] = true;
      return true;
    }).slice(0, 10).map(function (x) {
      return '<li><a class="vms-chip" href="' + esc(x.n.product.url) + '">' + esc(x.n.chip || x.n.label) + ' <small>· ' + esc(shortTitle(x.n.product.title)) + '</small></a></li>';
    }).join('');

    Array.prototype.forEach.call(document.querySelectorAll('predictive-search, search-form'), function (ps) {
      if (ps.__vms) return;
      ps.__vms = true;
      var input = ps.querySelector('input[type="search"]');
      var form = input && input.closest('form');
      if (!input || !form) return;
      var panel = document.createElement('div');
      panel.className = 'vms-panel';
      panel.hidden = true;
      panel.innerHTML = '<p class="vms-panel__t">' + esc(CFG.searchTitle || 'Procura por necessidade') + '</p><ul class="vms-chips">' + chips + '</ul>';
      form.appendChild(panel);
      function toggle() { panel.hidden = !(document.activeElement === input && !input.value.trim()); }
      input.addEventListener('focus', toggle);
      input.addEventListener('input', toggle);
      input.addEventListener('blur', function () { window.setTimeout(toggle, 200); });
      panel.addEventListener('mousedown', function (e) { if (!e.target.closest('a')) e.preventDefault(); });

      var results = ps.querySelector('[data-predictive-search]');
      if (results && 'MutationObserver' in window) {
        var mo = null;
        var inject = function () {
          var q = input.value || '';
          var m = matchNeeds(q);
          var old = results.querySelector('.vms-reco');
          if (!m.length) { if (old) old.remove(); return; }
          if (old && old.getAttribute('data-q') === q) return;
          mo.disconnect();
          if (old) old.remove();
          var el = document.createElement('div');
          el.className = 'vms-reco';
          el.setAttribute('data-q', q);
          el.innerHTML = recoHTML(m, q);
          results.insertBefore(el, results.firstChild);
          mo.observe(results, { childList: true });
        };
        mo = new MutationObserver(inject);
        mo.observe(results, { childList: true });
      }
    });

    if (/\/search\/?$/.test(window.location.pathname)) {
      var q = '';
      try { q = new URLSearchParams(window.location.search).get('q') || ''; } catch (e) { q = ''; }
      var m = matchNeeds(q);
      var main = document.getElementById('MainContent');
      if (m.length && main) {
        var box = document.createElement('div');
        box.className = 'vms-page';
        box.innerHTML = '<div class="vms-reco">' + recoHTML(m, q) + '</div>';
        var first = main.querySelector('.shopify-section');
        if (first && first.nextSibling) main.insertBefore(box, first.nextSibling); else main.insertBefore(box, main.firstChild);
      }
    }
  }

  /* ------------------------------------------------------------------ ofertas nos cartões de produto (home) */
  function initCardOffers() {
    var els = document.querySelectorAll('[data-vm-offer][data-pid]');
    if (!els.length || CFG.enabled === false) return;
    Array.prototype.forEach.call(els, function (el) {
      var pid = parseInt(el.getAttribute('data-pid'), 10);
      var best = null;
      CFG.rules.forEach(function (r) {
        if (!r.on || r.products.indexOf(pid) < 0) return;
        var list = r.gifts.filter(function (g) { return g.available !== false; }).map(function (g) {
          return { g: g, qty: r.scale ? Math.min(r.min, g.qty) : g.qty };
        }).filter(function (x) { return x.qty > 0; });
        if (!list.length) return;
        var val = sum(list, function (x) { return giftValue(x.g, x.qty); });
        // a oferta mais fácil de obter primeiro (menos unidades); em empate, a de maior valor
        if (!best || r.min < best.r.min || (r.min === best.r.min && val > best.val)) best = { r: r, list: list, val: val };
      });
      if (!best) return;
      var names = best.list.map(function (x) { return x.qty + ' ' + (x.g.title || 'brinde'); }).join(' + ');
      var txt = best.r.min > 1 ? 'Compre ' + best.r.min + ' e ganhe ' + names : 'Ganhe ' + names;
      el.innerHTML = ICON.gift + '<span>' + esc(txt) + '</span>';
      el.hidden = false;
    });
  }

  /* ------------------------------------------------------------------ arranque */
  var timer = null;
  function scheduleReconcile() {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      reconcile().then(function (res) {
        if (res.changed && IS_CART_PAGE) { window.location.reload(); return; }
        var d = getDrawer();
        if (d && typeof d.render === 'function' && (res.changed || d.classList.contains('is-open'))) d.render(res.cart);
        if (res.changed) announce(res.cart);
        else {
          try { document.dispatchEvent(new CustomEvent('vm:cart:updated', { detail: { cart: res.cart } })); } catch (e) { /* ignorar */ }
        }
      });
    }, 160);
  }

  function boot() {
    if (window.customElements && !window.customElements.get('cart-drawer') && document.querySelector('cart-drawer.vmc')) {
      window.customElements.define('cart-drawer', VmCartDrawerFactory());
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-vmh]'), initHero);
    initCardOffers();
    initSearch();
    initCartPage();

    if (hasPubSub() && typeof window.subscribe === 'function') {
      window.subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.source === 'vm-ofertas') return;
        scheduleReconcile();
      });
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) scheduleReconcile(); });

    var countEl = document.querySelector('[data-vm-cart-count]');
    var n = countEl ? parseInt(countEl.textContent, 10) : NaN;
    if (CFG.enabled !== false && (isNaN(n) || n > 0)) scheduleReconcile();
  }

  window.VMOfertas = {
    config: CFG,
    cart: Cart,
    reconcile: reconcile,
    evaluate: evaluate,
    open: function (trigger) { return openCart(trigger); },
    money: money
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
